<template>
<div class="chapter">
<div class="inner_page">
<p class="h12" id="d7e117013">Checklist for Life </p>
<p class="ext" id="d7e117513"><i>Courage is almost a contradiction in terms. It means a </i><i>strong desire to live taking the form of a readiness to die.</i></p>
<p class="ext1" id="d7e118313"><i>—G. K. Chesterton </i></p>
<p class="ext" id="d9t00813"><i>Let nothing be done through selfish ambition or conceit, </i><i>but in lowliness of mind let each esteem others better than </i><i>himself.</i></p>
<p class="ext1" id="d7e120113"><i>—Philippians 2:3 </i><i>NKJV </i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Inc_9781418557720_epub_c10_r1.vue?6558fcf4